import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getSocietyPeople = store => store[NAME].societyPeople;
export const getQuantityPerUsedEntryStructure = store => store[NAME].quantityPerUsedEntryStructure;
export const getEntryStructures = store => store[NAME].entryStructures;
export const getColaborators = store => store[NAME].colaborators;
export const getColumnTypes = store => store[NAME].columnTypes;
export const getSelects = store => store[NAME].selects;